module.exports = __webpack_public_path__ + "static/media/filter-remove.e84ae440.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filter-remove.svg
// module id = 1283
// module chunks = 1